<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h600_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="出库仓库">
                    <el-input
                      v-model="dialogAddEditForm.depotName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="出库时间"
                    prop="outdepotDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditForm.outdepotDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="出库类型">
                    <el-input
                      v-model="dialogAddEditForm.outdepotTypeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="调入库房">
                    <el-input
                      v-model="dialogAddEditForm.transferDepotName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="经办人"
                    prop="operater"
                  >
                    <el-input v-model="dialogAddEditForm.operater" />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              物料信息
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="materialListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                    />
                    <el-table-column
                      prop="schemeName"
                      label="方案名称"
                      show-overflow-tooltip
                    />
                    <el-table-column
                      prop="materialsName"
                      label="物料名称"
                      show-overflow-tooltip
                      width="200"
                    />
                    <el-table-column
                      prop="sourceTypeStr"
                      label="物料来源"
                      width="100"
                    />
                    <el-table-column
                      prop="unitName"
                      label="单位"
                      width="80"
                    />
                    <el-table-column
                      label="数量"
                      width="100"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.amount }}
                      </template>
                    </el-table-column>
                    <!-- <el-table-column
                      label="合计"
                      width="100"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.total }}
                      </template>
                    </el-table-column> -->
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box pic-container">
            <h3 class="modal-title">
              照片信息<span style="padding-left:30px;color:red">上传图片大小：小于5M; 格式：png、jpg、jpeg、gif</span>
            </h3>
            <div class="modal-row-box">
              <el-upload
                ref="picUpload"
                list-type="picture-card"
                :action="picUploadAction"
                :data="picData"
                :before-upload="beforeAvatarUpload"
                :file-list="initFileList"
                :on-preview="handlePictureCardPreview"
                :headers="{'X-Token': getToken()}"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
                :with-credentials="true"
                :on-success="function (res, file, fileList) {return handleSuccess (res, file, fileList, picList)}"
                :on-remove="(file,fileList)=>handlePictureCardRemove(file,fileList,picList)"
              >
                <el-button
                  type="success"
                  class="upload-button"
                  icon="el-icon-folder-opened"
                >
                  选择图片
                </el-button>
              </el-upload>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
      <el-dialog
        :visible.sync="dialogImageVisible"
        append-to-body
      >
        <img
          width="100%"
          :src="dialogImageUrl"
          alt=""
        >
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 数据请求
import { getToken } from "@/utils/auth"
import { initOutdepotBillApi, initOutdepotBillDetailApi, saveOrUpdateOutdepotBillApi } from '@/api/outdepotBill'
import { findAttachmentInfoByConditionApi, deleteFileApi, loadCurrentDateApi } from '@/api/common'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    },
    sendArray: {
      type: Array,
      default: null
    },
    outdepotType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogAddEditForm: {},
      dialogAddEditFormRules: {
        indepotDate: [{ required: true, message: '请选择入库时间', trigger: 'blur' }],
        operater: [{ required: true, message: '请输入经办人', trigger: 'blur' }, { max: 32, message: '经办人最多输入32个字符', trigger: 'blur' }],
        remark: [{ max: 128, message: '备注最多输入128个字符', trigger: 'blur' }]
      },
      currentDate: '',
      materialListData: [],
      picData: { directory: 'outdepotBill' },
      initFileList: [],
      dialogImageUrl: '',
      dialogImageVisible: false,
      picList: [], // 照片对象数组
      baseUrl: process.env.VUE_APP_BASE_API,
      picUploadAction: process.env.VUE_APP_BASE_API + '/web/common/uploadFile',
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this
        _this.loading = true
        _this.loadingText = '努力加载数据中，请耐心等待'
        _this.operateButtonDisable = false

        _this.picList = []
        _this.initFileList = []
        _this.depotOptions = []
        _this.materialListData = []
        _this.dialogAddEditForm = {
          depotId: '',
          depotName: '',
          outdepotDate: '',
          outdepotType: 0,
          outdepotTypeStr: '',
          schemeId: 0,
          operater: '',
          transferDepotId: '',
          transferDepotName: '',
          remark: ''
        }

        _this.initCurrentDate()
        if (_this.eventType !== 'add') {
          _this.initData()
        } else {
          _this.dialogAddEditForm.outdepotType = _this.outdepotType
          if (_this.outdepotType === 13) {
            _this.dialogAddEditForm.outdepotTypeStr = '调拨出库'
          }
          // 初始化出库物料明细数据
          _this.initMaterialsDataByAdd()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditForm.clearValidate()
          _this.loading = false
        })
      }
    }
  },
  methods: {
    getToken,
    // 新增时初始化出库物料明细内容
    initMaterialsDataByAdd() {
      let _this = this
      if (_this.outdepotType === 13) {
        _this.dialogAddEditForm.depotId = _this.sendArray[0].auditAllocateDepotId
        _this.dialogAddEditForm.depotName = _this.sendArray[0].auditAllocateDepotName
        _this.dialogAddEditForm.transferDepotId = _this.sendArray[0].receiveDepotId
        _this.dialogAddEditForm.transferDepotName = _this.sendArray[0].receiveDepotName

      }
      _this.sendArray.forEach(item => {
        let amount = item.auditAllocateNumber || 0
        if (amount > 0) {
          _this.materialListData.push({
            schemeId: item.schemeId || 0,
            schemeName: item.schemeName || '',
            schemeNo: item.schemeNo || '',
            materialsName: item.materialsName,
            materialsId: item.materialsId,
            sourceTypeStr: item.sourceTypeStr,
            sourceType: item.sourceType,
            unitName: item.materialsUnitName,
            unitId: item.materialsUnitId,
            price: 0,
            amount: amount,
            total: 0,
            demandId: item.id || 0
          })
        }
      })
    },
    // 初始化系统时间
    initCurrentDate() {
      loadCurrentDateApi().then(res => {
        const { data } = res
        this.dialogAddEditForm.outdepotDate = data
        this.currentDate = data.replace('-', '').replace('-', '')
      })
    },
    // 加载数据
    initData() {
      initOutdepotBillApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditForm) {
          if (key.endsWith('Date')) this.dialogAddEditForm[key] = data[key + 'Str']
          else if (key.endsWith('Id')) this.dialogAddEditForm[key] = Number(data[key])
          else this.dialogAddEditForm[key] = data[key]
        }

        this.dialogAddEditForm.id = data.id
        this.initDetailData()
      })
    },
    // 加载出库明细物料数据
    initDetailData() {
      initOutdepotBillDetailApi({ outdepotId: this.dataId }).then(res => {
        const { data } = res
        this.materialListData = data || []
        this.loading = false
      })
    },
    // 加载出库单附件数据
    loadBillFileData() {
      findAttachmentInfoByConditionApi({ sourceType: 4, sourceId: this.dataId }).then(res1 => {
        if (res1.data && res1.data.length > 0) {
          res1.data.forEach(item => {
            let obj = {}
            obj.name = item.attachmentName
            obj.url = this.baseUrl + item.attachmentUrl
            obj.attachmentName = item.attachmentName
            obj.attachmentUrl = item.attachmentUrl
            this.picList.push(obj)
            this.initFileList.push(obj)
          })
        }
      })
    },
    // 计算合计
    computedMathRow(val, obj, name) {
      if (name === 'amount') {
        if (val > Number(obj.maxAmount)) {
          val = Number(obj.maxAmount)
          obj[name] = val
        }
      }
      this.limitPositiveNumber(val, obj, name)
      this.setNumberZero(obj, name)
      obj['total'] = Number(obj['price']) * Number(obj['amount'])
    },
    // 图片上传前
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过5MB!')
        return false
      }
      this.isUploading = true
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    // 上传成功
    handleSuccess(res, file, fileList, dataObj) {
      if (res.mark === '200') {
        let fileObj = {}
        fileObj.attachmentName = res.myFileName
        fileObj.attachmentUrl = res.fileName
        fileObj.url = this.baseUrl + res.fileName
        dataObj.push(fileObj)
        this.isUploading = false
      } else {
        this.$message.error(res.message)
      }
    },
    // 删除
    handlePictureCardRemove(file, fileList, dataObj) {
      let fileUrl = ''
      if (file.response) {
        let resData = file.response
        let delIndex = dataObj.findIndex(item => {
          return item.attachmentUrl === resData.fileName
        })
        fileUrl = resData.fileName
        dataObj.splice(delIndex, 1)
      } else {
        let delIndex = dataObj.findIndex(item => {
          if (item.url === file.url) {
            fileUrl = item.attachmentUrl
            return item.url === file.url
          }
        })
        dataObj.splice(delIndex, 1)
      }
      if (fileUrl !== '') {
        deleteFileApi({ filePath: fileUrl }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
          }
        })
      }
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          if (this.materialListData.length === 0) {
            this.$message({ message: '无出库物料明细，不能保存', type: 'warning' })
            return false
          } else {
            let isZero = false
            this.materialListData.forEach(item => {
              if (Number(item.amount) === 0) {
                isZero = true
              }
            })
            if (isZero) {
              this.$message({ message: '出库物料数量不能为0，不能保存', type: 'warning' })
              return false
            }
          }
          if (Number(this.currentDate) < Number(this.dialogAddEditForm.outdepotDate.replace('-', '').replace('-', ''))) {
            this.$message({ message: '出库日期不能大于当前日期，不能保存', type: 'warning' })
            return false
          }
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '出库单', '系统提示',
            { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          ).then(async () => {
            this.operateButtonDisable = true
            this.loading = true
            this.loadingText = '正在处理数据中，请耐心等待'

            this.dialogAddEditForm.detailInfo = JSON.stringify(this.materialListData)
            let picUrls = []
            let picNames = []
            this.picList.forEach(item => {
              picUrls.push(item.attachmentUrl)
              picNames.push(item.attachmentName)
            })
            this.dialogAddEditForm.picUrls = JSON.stringify(picUrls)
            this.dialogAddEditForm.picNames = JSON.stringify(picNames)

            saveOrUpdateOutdepotBillApi(this.dialogAddEditForm).then(res => {
              if (res.mark === '200') {
                this.$message({ message: res.message, type: 'success' })
                this.reloadData()
                this.modalClose()
              }
            }).catch(() => {
              this.loading = false
              this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
::v-deep .special-row .el-col {
  min-height: 20px;
}
.pic-container {
  position: relative;
  .pic-name {
    display: inline-block;
    padding-top: 7px;
    margin-bottom: 10px;
  }
  .upload-button {
    position: absolute;
    top: 0;
    right: 0px;
  }
  ::v-deep .el-upload--picture-card i {
    font-size: 14px !important;
    color: #fff !important;
  }
  ::v-deep .el-upload--picture-card {
    border: none;
    height: 0px;
    overflow: hidden;
  }
}
::v-deep .el-upload-list--picture-card {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .el-upload-list__item {
    display: flex;
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    align-items: center;
    border-radius: 0;
  }
  .el-upload-list__item-thumbnail {
    height: auto;
    align-items: center;
  }
}
</style>
